module.exports = __webpack_public_path__ + "static/media/userinput.db4a29af.svg";